<template>
  <!-- 弹窗蒙板 -->
  <div
    v-show="isShow"
    ref="dialogMock"
    class="confirm-mock"
  >
    <!--弹窗窗体  -->
    <div
      ref="coDialog"
      class="confirm-dialog"
      :style="{marginLeft: left + 'px',marginTop: top + 'px'}"
    >
      <!-- 弹窗标题 -->
      <div class="confirm-title">
        <!-- 标题插槽 -->
        <slot name="title">
          <span>{{ $t(title) }}</span>
        </slot>
        <!-- 关闭图标 -->
        <span
          class="i-close"
          @click="close"
        >
          <svg class="close-svg">
            <use xlink:href="#close"/>
          </svg>
        </span>
      </div>
      <!-- 弹窗内容 -->
      <div
        class="confirm-content"
        :style="describe?{marginBottom:0}:{}"
      >
        <!-- 内容插槽 -->
        <slot name="content">
          <!-- 图标 -->
          <slot name="icon">
            <span
              class="icon"
              :class="iconType"
            >
              <svg class="icon-svg">
                <use :xlink:href="iconName"/>
              </svg>
            </span>
          </slot><!--
          --><span
          class="content"
          v-html="$t(content)"
        />
          <br>
          <span
            v-if="isDescribe"
            class="describe"
            v-html="$t(describe)"
          />
        </slot>
      </div>
      <!-- 弹窗底部 -->
      <div class="confirm-footer">
        <!-- 弹窗按钮组 -->
        <slot name="button">
          <co-button
            v-if="!onlyOne"
            @click="cancel"
          >
            {{ $t(cancelBtn) }}
          </co-button><!--
          -->
          <co-button
            v-if="extraBtn !== ''"
            @click="extra"
          >
            {{ $t(extraBtn) }}
          </co-button>
          <bs-button
            self-class="s-btn"
            @click="sure"
          >
            {{ $t(sureBtn) }}
          </bs-button>
        </slot>
      </div>
    </div>
    <div class="confirm-marsk" v-if="marskVisible"></div>
  </div>
</template>
<script>
import bsButton from 'components/business/link/lbutton/index.vue'
import coButton from 'components/common/button/index.vue'

export default {
  components: {
    bsButton,
    coButton,
  },
  props: {
    title: { // 定制标题
      type: String,
      default: '删除',
    },
    content: { // 定制内容
      type: String,
      default: '',
    },
    sureBtn: { // 确认按钮内容
      type: String,
      default: '确认',
    },
    cancelBtn: { // 取消按钮内容
      type: String,
      default: '取消',
    },
    extraBtn: {
      type: String,
      default: '',
    },
    iconType: { // 图标类型
      type: String,
      default: '',
    },
    value: { // 对话框显隐
      type: Boolean,
      default: false,
    },
    iconName: { // 图标名
      type: String,
      default: '#warn',
    },
    onlyOne: { // 按钮个数
      type: Boolean,
      default: true,
    },
    describe: { // 描述
      type: String,
      default: '',
    },
    isDescribe: { // 是否显示描述
      type: Boolean,
      default: true,
    },
    marskVisible: { // 是否显示遮罩
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      left: 0, // margin-left 居中用
      top: 0, // margin-top 居中用
      isShow: false, // 对话框显隐状态位

    }
  },
  watch: {
    value(n, o) {
      this.isShow = n
    },
    isShow: {
      handler(n, o) {
        this.$emit('input', n)
      },
      immediate: true,
    },
  },
  created() {
    this.isShow = this.value
  },
  mounted() {
    this.$nextTick(() => {
      this.setPosition()
    })
  },
  methods: {
    /**
     * 关闭弹框
     */
    close() {
      this.isShow = false
      this.$emit('close')
    },
    /**
     * 取消事件
     */
    cancel() {
      this.isShow = false
      this.$emit('cancel')
    },
    /**
     * 确认事件
     */
    sure() {
      this.isShow = false
      this.$emit('sure')
    },
    extra() {
      this.isShow = false
      this.$emit('extra')
    },
    /**
     * 设置弹框居中
     */
    setPosition() {
      const {style} = this.$refs.dialogMock // 设置下拉列表css 获取宽度
      style.display = 'block' // 弹框可以获取宽度，同时不占位置
      style.visibility = 'hidden'
      style.zIndex = -1000
      const coDialogWidth = this.$refs.coDialog.offsetWidth // 获取弹框宽度
      const coDialogHeight = this.$refs.coDialog.offsetHeight
      style.display = 'none' // 还原css
      style.visibility = ''
      style.zIndex = ''
      this.left = -coDialogWidth / 2 // 设置居中
      this.top = -coDialogHeight / 2 // 设置居中
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/dialog.less';

.icon-svg {
  width: 24px;
  height: 24px;
}

.confirm-dialog {
  font-size: 15px;
  max-width: 450px;
  z-index: 2;
}

.confirm-title {
  line-height: 24px;
}

.confirm-footer {
  clear: both;
}

.confirm-content {
  vertical-align: middle;
  font-size: 16px;
  padding: 0 24px;
  color: #1b2733;
  //   min-height: 48px;
  //   line-height: 48px;
  margin: 12px 0;
  line-height: 24px;
}

.content {
  word-break: break-all;
}

.describe {
  display: block;
  line-height: 20px;
  margin-left: 36px;
  word-break: break-all;
  font-size: 14px;
  color: #637282;
}

.icon {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  margin-bottom: 4px;
  margin-right: 12px;
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.confirm-marsk {
  background: rgba(0, 0, 0, .4);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
}
</style>
